export { default } from './mobile-card';
